var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "boxActions-MenuProgram",
    transform: "translate(-20.000000, -142.000000)",
    stroke: "#646464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-add",
    transform: "translate(0.000000, 141.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 4.8,
    x2: 9,
    y2: 13.2,
    id: "Stroke-234",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.2,
    y1: 9,
    x2: 4.8,
    y2: 9,
    id: "Stroke-235",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,0.5 C11.3471333,0.5 13.4721308,1.45143759 15.0103466,2.98965339 C16.5485624,4.52786919 17.5,6.65286667 17.5,9 C17.5,11.3471333 16.5485624,13.4721308 15.0103466,15.0103466 C13.4721308,16.5485624 11.3471333,17.5 9,17.5 C6.65286667,17.5 4.52786919,16.5485624 2.98965339,15.0103466 C1.45143759,13.4721308 0.5,11.3471333 0.5,9 C0.5,6.65286667 1.45143759,4.52786919 2.98965339,2.98965339 C4.52786919,1.45143759 6.65286667,0.5 9,0.5 Z",
    id: "Stroke-236"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdd);
export default __webpack_public_path__ + "static/media/ic-add.5e59db28516b188233c5773d57d46c4e.svg";
export { ForwardRef as ReactComponent };